import {
  ProjectManagementProjectDetailsPageSettingsBudgetSectionCreateBudgetDocument,
  ProjectManagementProjectDetailsPageSettingsBudgetSectionCreateBudgetMutation,
  ProjectManagementProjectDetailsPageSettingsPageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface createFixedTimeBudgetDto {
  projectId: number
  budgetAllocation: number
}

export const useCreateFixedTimeBudget = (companyId: number) => {
  const [createFixedTimeBudget] = useMutation(
    ProjectManagementProjectDetailsPageSettingsBudgetSectionCreateBudgetDocument,
    {
      extractorFn: (
        data: ProjectManagementProjectDetailsPageSettingsBudgetSectionCreateBudgetMutation
      ) => data.projectManagementMutations.createProjectmanagementFixedTimeBudget,
    }
  )

  return {
    create(dto: createFixedTimeBudgetDto) {
      const { projectId, budgetAllocation } = dto
      return createFixedTimeBudget({
        variables: {
          projectId,
          budgetAllocation,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: ProjectManagementProjectDetailsPageSettingsPageDocument,
            variables: { companyId, projectId, projectBudgetIsEnabled: true },
          },
        ],
      })
    },
  }
}
